import { GenericRequestBody, GenericResponse } from '@omnea-digital/toolbox'
import createClient from 'openapi-fetch'
import { withErrorCapture } from 'utils/general/observability/withErrorCapture'
import { ServiceUrls } from 'utils/general/serviceUrls'
import {
  openApiFetchAuthMiddleware,
  type AuthorizationMiddlewareOptions,
} from '@omnea-app/packages/universal/open-api-fetch/openApiFetchAuthMiddleware'
import { paths } from './rfxGeneratedTypes'

export type ScoresByOrgSupplierId =
  paths['/tasks/{taskId}/responses-and-scores']['get']['responses']['200']['content']['application/json']['scoresByOrgSupplierId']

export type AiScoresByOrgSupplierId =
  paths['/tasks/{taskId}/responses-and-scores']['get']['responses']['200']['content']['application/json']['aiScoresByOrgSupplierId']

export type AiScore = AiScoresByOrgSupplierId[string][string]

export type AiConfidenceRating = AiScore['confidence']['rating']

export type UpdateRfx = NonNullable<paths['/{rfxId}/update-state']['post']['requestBody']>['content']['application/json']

export type RfxDetail = paths['/{rfxId}']['get']['responses']['200']['content']['application/json']

export type RfxScoringProgress = paths['/{rfxId}/scoring-progress']['get']['responses']['200']['content']['application/json']

export type RfxAiScoringStatus = paths['/{rfxId}/ai-scoring-status']['get']['responses']['200']['content']['application/json']

export type RfxPricingAnalysisStatus =
  paths['/{rfxId}/pricing-analysis/{formTemplateId}/status']['get']['responses']['200']['content']['application/json']

export type RfxFormTemplateInsightsStatus =
  paths['/{rfxId}/form-template-insights/status']['get']['responses']['200']['content']['application/json']

export type RfxFormTemplateInsight =
  paths['/{rfxId}/form-template-insights']['get']['responses']['200']['content']['application/json']['insights'][number]

export type RfxSupplierStatus = NonNullable<
  paths['/{rfxId}/rfx-supplier/{rfxSupplierId}/set-status']['post']['requestBody']
>['content']['application/json']['status']

export type UpdateRfxSettings = NonNullable<paths['/{rfxId}/settings']['post']['requestBody']>['content']['application/json']

export type RfxResponse<T extends keyof paths, T2 extends keyof paths[T]> = GenericResponse<paths, T, T2>
export type RfxApiRequestBody<TPath extends keyof paths, TMethod extends keyof paths[TPath]> = GenericRequestBody<
  paths,
  TPath,
  TMethod
>

type Options = {
  authorization: AuthorizationMiddlewareOptions
}

export class RfxHttpClient {
  GET
  POST
  constructor({ authorization }: Options) {
    const client = createClient<paths>({ baseUrl: ServiceUrls.RFX })

    client.use(openApiFetchAuthMiddleware(authorization))

    this.GET = withErrorCapture({ method: client.GET })
    this.POST = withErrorCapture({ method: client.POST })
  }
}
